common.View.create('story::canvas.blocks.modules.storyHighlightSlider.Block', {

    onDOMLoad()
    {
        this.initSlider();
    },

    initSlider()
    {
        this.element.find('.owl-carousel').owlCarousel({
            loop: true,
            margin: 15,
            items: 1,
            nav: true, 
            navContainer: this.element.find('.owl-nav').get(0),
            navText : ["<i class='fa fa-arrow-left'></i>","<i class='fa fa-arrow-right'></i>"],
            dots: false,
            center: true,
            // autoplay: false,
            //autoplayTimeout: 4444,
            //autoplayHoverPause:true,
            stageClass: 'owl-stage flex',
            responsive: {
                0: {
                    items: 1.2
                },
                640: {
                    items: 1.5
                },
                1024: {
                    items: 2.5
                }
            }
        });

    }
});
